// extracted by mini-css-extract-plugin
export default {"container":"Supplies_container__mhSFW","reservationContent":"Supplies_reservationContent__ZRNnV","customTitle":"Supplies_customTitle__ZExOk"};